// Campos que recebem máscara no front (CEP, CPF/CNPJ, telefone e celular).
// O back deve receber apenas os dígitos, sem a pontuação/máscara, mas o
// formulário do front continua exibindo o valor mascarado normalmente.
export const MASKED_FIELDS = [
  'cpf_or_cnpj',
  'cpf_or_cnpj_property',
  'zipcode',
  'owner_zipcode',
  'cellphone',
  'cellphone_company',
  'phone',
  'phone_company',
  'owner_phone',
  'reference_client_phone',
];

// Remove tudo que não for dígito de um valor.
export function unmaskValue(value: any): any {
  if (typeof value !== 'string') return value;
  return value.replace(/\D/g, '');
}

// Retorna uma CÓPIA do objeto com os campos mascarados contendo apenas dígitos.
// Não altera o objeto original, para que o front continue mostrando a máscara.
export function unmaskFields<T extends Record<string, any>>(
  data: T,
  fields: string[] = MASKED_FIELDS
): T {
  const result: any = { ...data };
  fields.forEach((field) => {
    if (typeof result[field] === 'string') {
      result[field] = unmaskValue(result[field]);
    }
  });
  return result;
}
